import { render, staticRenderFns } from "./SelectedProductCard.vue?vue&type=template&id=853d1070&scoped=true"
import script from "./SelectedProductCard.vue?vue&type=script&lang=js"
export * from "./SelectedProductCard.vue?vue&type=script&lang=js"
import style0 from "./SelectedProductCard.vue?vue&type=style&index=0&id=853d1070&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853d1070",
  null
  
)

export default component.exports